import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { QuickImportProjectScanMethodsSettings } from '../../../../shared/settings/project/scanMethods';

/**
 * Fetches the quick-import scan-methods (vendored / snippet) org-default settings.
 */
export default function useOrganizationQuickImportScanMethodsSettings(
  organizationId: number,
  shouldFetch: boolean = true,
) {
  return useQuery({
    queryKey: ['organization', organizationId, 'settings', 'quick-import-scan-methods'],
    queryFn: () =>
      get<QuickImportProjectScanMethodsSettings>(
        `/api/organizations/${organizationId}/settings/projects/quick-import-scan-methods`,
      ),
    enabled: shouldFetch,
  });
}
